// codeOrderingConfig.js - Priority ordering for echo codes
// Codes listed here will appear first, in this exact order
// Codes not listed will appear after, in their original order

export const CODE_PRIORITY_ORDER = {
  vg: [
    'LV-0201', 'LV-0202',  // MAPSE septal/latéral - always first
    'LV-0194',             // FE visuellement estimée
    'LV-0077',             // FE normale
    'LV-0148',             // FE diminuée
    'LV-0196',             // Fonction longitudinale
    'LV-0195',             // Fonction systolique globale normale
    // Diastolic function codes
    'LV-0199', 'LV-0210', 'LV-0211', 'LV-0216',
    // Filling pressure codes
    'LV-0214', 'LV-0215'
  ],
  vd: [
    'RV-0071',  // TAPSE
    'RV-0072',  // Onde S' anneau tricuspidien
    'RV-0076',  // Paramètres deplacement longitud
    'RV-0064',  // Paramètres longitudinaux
    'RV-0067',  // Fonction longitudinale VD altérée
    'RV-0075',  // Paramètres de la déformation longitudinale
    'RV-0070',  // Fonction radiale VD
    'RV-0079',  // FE du VD préservée
    'RV-0069',  // FE du VD normale/diminuée
    'RV-0036',  // Fonction systolique normale
    'RV-0065',  // Fonction systolique globale préservée
    'RV-0068'   // Fonction systolique globale VD altérée
  ],
  oreillettes: [
    // OG (LA) codes first
    'LA-0036',  // OG planimètrée
    'LA-0046',  // OG normale en surface planimètrée
    'LA-0040',  // OG dilatée en planimétrie
    'LA-0041',  // OG dilatée en volume
    'LA-0028',  // OG dilatée
    'LA-0043',  // OG normale en volume
    'LA-0013',  // OG de taille normale
    'LA-0044',  // OG paraît de taille normale
    'LA-0045',  // OG paraissant dilatée
    // OD (RA) codes
    'RA-0042',  // OD planimètrée
    'RA-0044',  // OD dilatée en planimétrie
    'RA-0049',  // OD normale en surface planimètrée
    'RA-0051',  // OD dilatée en volume
    'RA-0050',  // OD normale en volume
    'RA-0020',  // OD dilatée
    'RA-0017',  // OD de taille normale
    'RA-0053',  // OD paraît de taille normale
    'RA-0054',  // OD paraissant dilatée
    // VCI codes last
    'RA-0034',  // Diam VCI normal avec variation respiratoire
    'RA-0052',  // Diam VCI de taille normale
    'RA-0027',  // VCI dilatée, pression OD accrue probable
    'RA-0038',  // VCI dilatée mais variation respiratoire normale
    'RA-0037',  // Veine cave inférieure collabée
    'RA-0045',  // Veine cave inférieure mal visualisée
    'RA-0043',  // VCI dilatée avec diminution de la variation respi
    'RA-0028',  // Diam. VCI non modifié par respiration
    'RA-0039'   // Diamètre VCI normal mais dim. var. respiratoire
  ]
};

/**
 * Sort codes by priority order for a given category
 * @param {Array} codes - Array of code objects with 'code' property
 * @param {string} category - Category key (vg, vd, oreillettes, etc.)
 * @returns {Array} Sorted codes array
 */
export function sortCodesByPriority(codes, category) {
  if (!codes || codes.length === 0) return codes;

  const priorityOrder = CODE_PRIORITY_ORDER[category];
  if (!priorityOrder) return codes;

  return [...codes].sort((a, b) => {
    const indexA = priorityOrder.indexOf(a.code);
    const indexB = priorityOrder.indexOf(b.code);

    // Both have priority: sort by priority order
    if (indexA !== -1 && indexB !== -1) return indexA - indexB;
    // Only A has priority: A comes first
    if (indexA !== -1) return -1;
    // Only B has priority: B comes first
    if (indexB !== -1) return 1;
    // Neither has priority: keep original order
    return 0;
  });
}

export default {
  CODE_PRIORITY_ORDER,
  sortCodesByPriority
};
